exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports
exports.locals = {
	"menuText": "#bfcbd9",
	"menuActiveText": "#409EFF",
	"subMenuActiveText": "#f4f4f5",
	"menuBg": "#393e46",
	"menuHover": "#393e46",
	"subMenuBg": "#1C1F27",
	"subMenuHover": "#1C1F27",
	"sideBarWidth": "245px"
};